import React from 'react';

export default function Skeleton({ className = '', variant = 'rect' }) {
  const baseClass = "animate-pulse bg-gray-200";
  const roundedClass = variant === 'circle' ? 'rounded-full' : 'rounded';
  
  return (
    <div className={`${baseClass} ${roundedClass} ${className}`}></div>
  );
}
